var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.Lead && _vm.Lead.info
    ? _c("div", { staticClass: "lead-view-left" }, [
        _c("div", { staticClass: "lead-info" }, [
          _c("div", { staticClass: "lead-brand" }, [
            _c("div", { staticClass: "lead-brand-content" }, [
              _c("div", { staticClass: "lead-icon" }),
              _vm._v(" "),
              _c("div", { staticClass: "lead-info-name" }, [
                _vm._v(_vm._s(_vm.Lead.info.lastname)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "lead-info-home" }, [
                _c(
                  "a",
                  {
                    staticClass: "lead-clickable-elem-color",
                    attrs: { href: _vm.Lead.info.autologin },
                  },
                  [
                    _c("img", {
                      attrs: { src: "/img/home/t_logo_Fxbullion.com.png" },
                    }),
                    _vm._v(_vm._s(_vm.Lead.info.home) + "\n          "),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "lead-info-leadid" }, [
                  _vm._v(_vm._s(_vm.Lead.info.login)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cob-btn", attrs: { "data-login": "183365" } },
                  [
                    _c("img", {
                      staticClass: "cob-btn--item",
                      attrs: { "data-login": "183365", src: "/img/cob.svg" },
                      on: { click: _vm.openCb },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "lead-brand-status-assign-wrap" }, [
                _c("div", { staticClass: "lead-info-status td--salestatus" }, [
                  _c("div", { staticClass: "ui-ddbox ui-ddbox-select c-1" }, [
                    _c("button", { staticClass: "ui-ddbtn" }, [
                      _c(
                        "span",
                        {
                          staticClass: "ui-ddbtnvalue",
                          on: {
                            click: function ($event) {
                              _vm.isStatusPopup = !_vm.isStatusPopup
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.Lead.info.leadstatus) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa fa-caret-down",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ui-ddbody" }, [
                      _vm.App.leadstatus && _vm.isStatusPopup
                        ? _c(
                            "div",
                            { staticClass: "ui-ddsection ui-salestatusList" },
                            [
                              _c(
                                "ul",
                                _vm._l(_vm.App.leadstatus, function (status) {
                                  return _c(
                                    "li",
                                    {
                                      class: {
                                        "favor-status":
                                          _vm.LeadStatusFavor.includes(
                                            status.leadstatus
                                          ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeLeadStatus(status)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(status.leadstatus) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ui-ddbox ui-ddbox-select" }, [
                  _c("button", { staticClass: "ui-ddbtn" }, [
                    _c(
                      "span",
                      {
                        staticClass: "ui-ddbtnvalue",
                        on: {
                          click: function ($event) {
                            _vm.isUsersPopup = !_vm.isUsersPopup
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.Lead.info.user_name) +
                            "\n              "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-caret-down",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui-ddbody" }, [
                    _vm.App.users && _vm.isUsersPopup
                      ? _c(
                          "div",
                          { staticClass: "ui-ddsection ui-assignedtoList" },
                          [
                            _c(
                              "ul",
                              _vm._l(_vm.App.users, function (user) {
                                return _c(
                                  "li",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeUserStatus(user)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(user.user_name) +
                                        "\n                  "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "lead-details" }, [
            _c("div", { staticClass: "lead-info-phone" }, [
              _c("div", { staticClass: "field-title" }, [
                _vm._v(_vm._s(_vm.front.phone)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field-content" }, [
                _c(
                  "a",
                  {
                    staticClass: "phone_number",
                    class: { cursorPointer: _vm.isCursorPointer },
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        return _vm.getCall(0, "", "")
                      },
                    },
                  },
                  [_c("svg-phone")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "phone_number",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        return _vm.getCall(1, "", "")
                      },
                    },
                  },
                  [_c("svg-incognito")],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "lead-info-email" }, [
              _c("div", { staticClass: "field-title" }, [
                _vm._v(_vm._s(_vm.front.email)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field-content" }, [
                _c(
                  "a",
                  {
                    staticClass: "lead-clickable-elem-color",
                    attrs: { href: "mailto:" + _vm.Lead.info.email },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.Lead.info.email) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "lead-info-country" }, [
              _c("div", { staticClass: "field-title" }, [
                _vm._v(_vm._s(_vm.front.country)),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "field-content" },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.Lead.info.country) + " (+02:00 GMT)"),
                  ]),
                  _vm._v(" "),
                  _c("current-time"),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "lead-info-lp" }, [
              _c("div", { staticClass: "field-title" }, [
                _vm._v(_vm._s(_vm.front.landingPage)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field-content" }, [
                _c(
                  "a",
                  {
                    staticClass: "lead-clickable-elem-color",
                    attrs: {
                      href: "https://" + _vm.Lead.info.landing,
                      target: "_blank",
                    },
                  },
                  [_vm._v(_vm._s(_vm.Lead.info.landing))]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "lead-info-regdate" }, [
              _c("div", { staticClass: "field-title" }, [
                _vm._v(_vm._s(_vm.front.regDate)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field-content" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.Lead.info.createddate) +
                    " " +
                    _vm._s(_vm.Lead.info.createdtime) +
                    "\n        "
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "lead-clones" }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }